import { createContext, useContext } from 'react'

/** Opens the primers grid's paste box, from a card above it; absent where the step has no grid. */
export const PrimerPasteContext = createContext<(() => void) | undefined>(undefined)

export const usePrimerPasteRequest = (): (() => void) | undefined => useContext(PrimerPasteContext)
